export const checkUrl = (url) => {
    return url && (url.startsWith("http://") || url.startsWith("https://")) ? true : false
}